import React, { FunctionComponent } from 'react';
import { CharityExternalLinks } from '../../../types/__generated__';

import AboutRelationship from '../AboutRelationship/AboutRelationship';
import PageList from '../PageList/PageList';

interface AboutCampaignProps {
  campaigns: {
    logo: string;
    title: string;
    url: string;
    summary?: string | null;
    id: string;
    branding?: {
      logo?: string | null;
    };
    charities: {
      name: string;
      url: string;
    }[];
    campaignsUrls?: CharityExternalLinks | null;
  }[];
}

const AboutCampaign: FunctionComponent<AboutCampaignProps> = ({
  campaigns,
}) => {
  if (campaigns.length === 1) {
    const campaign = campaigns[0];

    const campaignLogo = campaign.branding?.logo ?? campaign.logo;

    const charity =
      campaign.charities && campaign.charities.length === 1
        ? campaign.charities[0]
        : undefined;

    return (
      <AboutRelationship
        logo={campaignLogo}
        name={campaign.title}
        parentName={charity && charity.name}
        parentPageUrl={charity && charity.url}
        landingPageUrl={campaign.url}
        description={campaign.summary}
        logoVariant="normal"
        campaignsUrls={campaign.campaignsUrls}
      />
    );
  }
  if (campaigns.length > 1) {
    return (
      <PageList
        pages={campaigns.map(x => ({
          url: x.url,
          logo: x.logo || '',
          campaignId: x.id,
          title: x.title,
        }))}
      />
    );
  }
  return null;
};

export default AboutCampaign;
